<template>
  <div class="layout-main py-1 flex">
    <div class="layout-main-sidebar h-full shadow bg-white hidden md:flex mr-3" :style="`width: ${isCollapse ? '72px' : '200px'}`">
      <el-scrollbar>
        <el-menu :collapse-transition="false" default-active="/dashboard/index" :style="`border:0;width: ${isCollapse ? '72px' : '200px'}`" :collapse="isCollapse">
          <router-link to="/dashboard/index">
            <el-menu-item index="999">
              <el-icon>
                <home-filled />
              </el-icon>
              <template #title>首页</template>
            </el-menu-item>
          </router-link>

          <template v-for="item of menuList" :key="item.id">
            <!-- 非菜单组，即菜单 -->
            <router-link :to="item.frontRoute" v-if="!item.groupMenu&&item.frontRoute!=`/dashboard`">
              <el-menu-item :index="item.frontRoute">
                <el-icon v-html="item.iconType"></el-icon> 
                <!-- <span v-html="icon"></span> -->
                <template #title>{{ item.name }}</template>
              </el-menu-item>
            </router-link>
            <!-- 菜单组  -->
            <el-sub-menu  :index="item.id+''" v-if="item.groupMenu&&item.children.length>0">
              <template #title>
                <el-icon v-html="item.iconType"></el-icon> 
                <!-- <span v-html="icon"></span> -->
                <span>{{ item.name }}</span>
              </template>
              <router-link :to="childItem.frontRoute" v-for="childItem of item.children" >
                <el-menu-item  :index="childItem.frontRoute" v-if="childItem&&childItem.display">
                  <el-icon v-html="childItem.icon"></el-icon>
                  {{
                    childItem.name
                  }}
                </el-menu-item>
              </router-link>
            </el-sub-menu>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>

    <el-drawer title="SideBar" size="200" v-model="isShowDrawer" direction="ltr" :with-header="false">
      <el-scrollbar>
        <el-menu :collapse-transition="false" default-active="/dashboard/index" style="width: 200px;" @select="menuSelectedInDrawer">
          <router-link to="/dashboard/index">
            <el-menu-item index="999">
              <el-icon>
                <home-filled />
              </el-icon>
              <template #title>首页</template>
            </el-menu-item>
          </router-link>

          <template v-for="item of menuList" :key="item.id">
            <!-- 非菜单组，即菜单 -->
            <router-link :to="item.frontRoute" v-if="!item.groupMenu&&item.frontRoute!=`/dashboard`">
              <el-menu-item :index="item.frontRoute">
                <el-icon v-html="item.iconType"></el-icon> 
                <!-- <span v-html="icon"></span> -->
                <template #title>{{ item.name }}</template>
              </el-menu-item>
            </router-link>
            <!-- 菜单组  -->
            <el-sub-menu  :index="item.id+''" v-if="item.groupMenu&&item.children.length>0">
              <template #title>
                <el-icon v-html="item.iconType"></el-icon> 
                <!-- <span v-html="icon"></span> -->
                <span>{{ item.name }}</span>
              </template>
              <router-link :to="childItem.frontRoute" v-for="childItem of item.children" >
                <el-menu-item  :index="childItem.frontRoute" v-if="childItem&&childItem.display">
                  <el-icon v-html="childItem.icon"></el-icon>
                  {{
                    childItem.name
                  }}
                </el-menu-item>
              </router-link>
            </el-sub-menu>

          </template>
        </el-menu>
      </el-scrollbar>
    </el-drawer>
    <el-scrollbar class="flex-1 layout-main-content">
      <div class="flex-1 shadow bg-white p-3">
        <router-view v-slot="{ Component }" >
          <keep-alive :include="cachedRoutes">
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </div>
    </el-scrollbar>
    <div></div>
  </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { onMounted } from "vue";
import { HomeFilled, Tools } from '@element-plus/icons-vue'
// import { ElScrollbar,ElMenu,ElMenuItem,ElSubmenu,ElMenuItemGroup,ElDrawer } from "element-plus";
import MittUtils from "../../utils/MittUtils";
import { useMenuStore } from "../../store/menuStore";

defineOptions({
  name: "LayoutMain",
});
const router = useRouter();
// 动态计算需要缓存的路由名称
const cachedRoutes = computed(() => {
  let arr =  router.getRoutes().filter((r) => r.meta?.keepAlive).map( r => {  return r.name;} );  
  // 过滤掉 undefined 值
  const validRoutes = arr.filter((name): name is string => name !== undefined);
  return validRoutes;
});
const mainMenu = useMenuStore();
//定义菜单
const menuList = ref([]);
const isCollapse = ref(false);
const isShowDrawer = ref(false);
const mobileOffSetWidth = ref(1024);
const icon = ` <el-icon><location /></el-icon>`
const menuSelectedInDrawer = () => {
  isShowDrawer.value = false;
}
MittUtils.on("isCollapse", (e: boolean) => {
  isCollapse.value = e;
  if (mobileOffSetWidth.value < 768) {
    isShowDrawer.value = true;
  }
});
//订阅store状态的变化，类似 watch
mainMenu.$subscribe((mutation, state) => {
  console.log("----------$subscribe------------", state.menus);
  //@ts-ignore
  menuList.value = state.menus;
});
onMounted(() => {
  //初始化菜单
  menuList.value = mainMenu.menus;
  // console.log(JSON.stringify(menuList.value))
  mobileOffSetWidth.value = document.body.offsetWidth;
  console.log("mounted mobileOffSetWidth:" + mobileOffSetWidth.value);
  // console.log("menuList:" + JSON.stringify(menuList.value));
  //监听页面宽度变化
  window.addEventListener("resize", () => {
    console.log("document.body.offsetWidth:" + document.body.offsetWidth);
    setTimeout(() => {
      mobileOffSetWidth.value = document.body.offsetWidth;
    }, 300);
  });
});
</script>
<style lang="postcss" scoped>
.layout-main-sidebar {
  height: calc(100vh - 80px);
  transition: width 0.35s;
}
.layout-main-content {
  height: calc(100vh - 66px);
}
</style>

<style lang="postcss">
li.el-menu-item {
  font-size: 15px;
  font-weight: bold;
  color: #555;
}
.el-sub-menu__title {
  /* font-size: 15px !important; */
  font-weight: bold;
  color: #555;
}
li.el-sub-menu li.el-menu-item {
  color: gray;
  padding-left: 30px !important;
}
</style>
